import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Chip,
  Typography,
} from "@mui/material";
import CustomButton from "../mui-styles/CustomButton";

export default function ProjectsItem({ notion }) {
  const { title, cover, description, internetUrl, hashtag } = notion;

  return (
    <Card
      sx={{
        maxWidth: 345,
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <Box p={2}>
        <Typography gutterBottom variant="h6" component="div">
          {title}
        </Typography>
        <CardMedia
          component="img"
          alt={title}
          height="140"
          image={cover}
          sx={{ borderRadius: "10px 10px 0 0 " }}
        />
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            height: 80,
            overflow: "hidden",
            p: 1,
          }}
        >
          {hashtag.map((item, index) => (
            <Typography component="span" key={index}>
              <Chip label={item} sx={{ blockSize: 20, fontSize: 10 }} />
            </Typography>
          ))}
        </Box>

        <CardContent sx={{ height: 100 }}>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              overflow: "auto",
              maxHeight: "85px",
              "::-webkit-scrollbar": {
                display: "none",
              },
              cursor: "default",
            }}
          >
            {description}
          </Typography>
        </CardContent>
        <CardActions>
          <CustomButton
            variant="contained"
            size="small"
            href={internetUrl}
            rel="noopener"
            target="_blank"
          >
            visit code🪧
          </CustomButton>
        </CardActions>
      </Box>
    </Card>
  );
}
